import React, { useState, useEffect, useMemo, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useOutletContext } from "react-router-dom";

import { AgGridReact } from "ag-grid-react"; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid

import "./index.css";

function renderState() {
  return "Uncontacted";
}

const url = "/api/prospects/";

// Skills are stored comma-separated ("Java, AWS, Git").
function parseSkills(value) {
  return value ? value.split(/,\s*/).filter(Boolean) : [];
}

function ProspectPage() {
  const { setScrapeFunction, setOpenToWorkFunction } = useOutletContext();

  useEffect(() => {
    fetch(url, { redirect: "manual" }).then((response) => {
      //const totalCount = response.headers.get("X-Total-Count");
      return response.json().then((data) => {
        setRowData(data);
        return data;
      });
    });
  }, []);

  const [rowData, setRowData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const gridApiRef = useRef(null);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [email, setEmail] = useState("hannes@bjurek.se");
  const [password, setPassword] = useState("");
  const [cookies, setCookies] = useState("");
  const [selectedLinkedinIds, setSelectedLinkedinIds] = useState([]);
  const [skillsModal, setSkillsModal] = useState(null);

  //https://docs.google.com/spreadsheets/d/1DG2oGjVKE5Vn_eD93oBKvBCKWcdbP0_h3zBS7rX1up8/edit?gid=723516482#gid=723516482&range=A200

  const CustomLinkedinCell = (props) => {
    var linkedId = props.getValue();
    var linkedUrl = "https://linkedin.com/in/" + linkedId + "/";
    return (
      <a href={linkedUrl} target="_new">
        {linkedId}
      </a>
    );
  };

  const CustomRowCell = (props) => {
    var row = props.getValue();
    var rowUrl =
      "https://docs.google.com/spreadsheets/d/1DG2oGjVKE5Vn_eD93oBKvBCKWcdbP0_h3zBS7rX1up8/edit?gid=723516482#gid=723516482&range=A" +
      row +
      "/";
    return (
      <a href={rowUrl} target="_new">
        {row}
      </a>
    );
  };

  const CustomButtonComponent = (props) => {
    var notes = props.getValue();

    if (typeof notes !== "undefined") {
      if (notes.length > 0) {
        return <span>Notes</span>;
      } else {
        return <></>;
      }
    }
  };

  function addContactDate(linkedinId) {
    console.log("add date to " + linkedinId);
    var url = "/api/prospects/addContactDate/" + linkedinId;

    fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        console.log("Contaced dates updated:");
        console.log(response);
        return response.json();
      })
      .then((result) => {
        console.log(result);
        console.log(gridApi);
        gridApiRef.current.applyTransaction({ update: [result] });
      });
  }
  const ContactDatesRenderer = (props) => {
    var contactDates = props.getValue();

    return (
      <span>
        <button onClick={() => addContactDate(props.data.linkedinId)}>+</button>{" "}
        {contactDates.join(", ")}
      </span>
    );
  };

  const RecruiterRenderer = (props) => {
    var value = props.getValue();
    if (value === "hannes.bjurek") {
      return "Hannes";
    } else if (value === "mikael.backstrom") {
      return "Mikael";
    }
  };

  // Shows the number of skills; clicking it opens the full list.
  const SkillsRenderer = (props) => {
    const buttonRef = useRef(null);
    const skills = parseSkills(props.getValue());

    // A native listener that stops the click, so opening the list doesn't
    // also select the row (the grid selects rows on click).
    useEffect(() => {
      const button = buttonRef.current;
      if (!button) return;
      const onClick = (event) => {
        event.stopPropagation();
        setSkillsModal({
          name: `${props.data.firstName} ${props.data.lastName}`,
          skills: skills,
        });
      };
      button.addEventListener("click", onClick);
      return () => button.removeEventListener("click", onClick);
    });

    if (skills.length === 0) return "";
    return (
      <button ref={buttonRef} className="text-blue-600 underline">
        {skills.length}
      </button>
    );
  };
  // Column Definitions: Defines the columns to be displayed.
  const [colDefs, setColDefs] = useState([
    { field: "row", sort: "desc", width: 70, cellRenderer: CustomRowCell },
    {
      field: "firstName",
      width: 130,
      filter: true,
      filterParams: {
        applyMiniFilterWhileTyping: true,
      },
    },
    {
      field: "lastName",
      width: 130,
      filter: true,
      filterParams: {
        applyMiniFilterWhileTyping: true,
      },
    },
    { field: "linkedinId", cellRenderer: CustomLinkedinCell, width: 250 },
    {
      field: "assignedRecruiter",
      headerName: "Recruiter",
      filter: true,
      cellRenderer: RecruiterRenderer,
      filterParams: {
        applyMiniFilterWhileTyping: true,
      },
      cellEditor: "agSelectCellEditor",
      cellEditorParams: {
        values: ["hannes.bjurek", "mikael.backstrom"],
      },
      width: 130,
      editable: true,
    },

    {
      field: "contactDates",

      cellRenderer: ContactDatesRenderer,
    },

    { field: "currentEmployer" },
    {
      field: "skills",
      cellRenderer: SkillsRenderer,
      comparator: (a, b) => parseSkills(a).length - parseSkills(b).length,
      width: 90,
    },
    {
      field: "notes",
      editable: true,
      // cellRenderer: CustomButtonComponent,
      // width: 70,
      cellEditor: "agLargeTextCellEditor",
      cellEditorPopup: true,
      flex: 2,
    },
  ]);

  function notesRender(value) {
    if (value.length > 2) {
      return "N";
    } else {
      return "";
    }
  }

  function recruiterRender(value) {}

  function datesRender(value) {
    if (value.length === 0) {
      return "";
    } else if (value.length === 1) {
      return value;
    } else if (value.length === 2) {
      return value[0] + ", " + value[1];
    }
  }

  const rowSelection = useMemo(() => {
    return {
      mode: "multiRow",
      checkboxes: true,
      enableClickSelection: true,
    };
  }, []);

  function onCellValueChanged(event) {
    var url = "/api/prospects/";

    url = url + event.data.linkedinId;
    console.log("contactDates:" + event.data.contactDates);
    fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(event.data),
    })
      .then((response) => {
        console.log("User updated:");
        console.log(response);
      })
      .then((result) => {
        console.log("Success:", result);
      });
    console.log("cell edit:" + event);
  }

  const getRowId = (params) => params.data.linkedinId;

  const onGridReady = (params) => {
    setGridApi(params.api);
    gridApiRef.current = params.api;
  };

  const handleScrape = () => {
    if (!gridApiRef.current) {
      alert("Grid not ready yet.");
      return;
    }

    const selectedRows = gridApiRef.current.getSelectedRows();
    const linkedinIds = selectedRows.map((row) => row.linkedinId);

    if (linkedinIds.length === 0) {
      alert("Please select at least one row to scrape.");
      return;
    }

    setSelectedLinkedinIds(linkedinIds);
    setShowPasswordModal(true);
  };

  const handleOpenToWork = () => {
    if (!gridApiRef.current) {
      alert("Grid not ready yet.");
      return;
    }

    const selectedRows = gridApiRef.current.getSelectedRows();
    const linkedinIds = selectedRows.map((row) => row.linkedinId);

    if (linkedinIds.length === 0) {
      alert("Please select at least one row to check open to work status.");
      return;
    }

    const requestData = {
      linkedinIds: linkedinIds,
    };

    fetch("/api/findOpenToWork", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    })
      .then((response) => {
        console.log("Open to work request sent:");
        console.log(response);
        if (response.ok) {
          alert(`Open to work check sent for ${linkedinIds.length} profiles.`);
        } else {
          alert("Error sending open to work request.");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("Error sending open to work request.");
      });
  };

  const handlePasswordConfirm = () => {
    let parsedCookies;
    try {
      parsedCookies = cookies.trim() ? JSON.parse(cookies) : {};
    } catch (error) {
      alert("Invalid JSON format for cookies. Please check your input.");
      return;
    }

    const requestData = {
      linkedinIds: selectedLinkedinIds,
      cookies: parsedCookies,
    };

    fetch("/api/scrape", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    })
      .then((response) => {
        console.log("Scrape request sent:");
        console.log(response);
        if (response.ok) {
          alert(
            `Scrape request sent for ${selectedLinkedinIds.length} profiles.`
          );
        } else {
          alert("Error sending scrape request.");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("Error sending scrape request.");
      })
      .finally(() => {
        setShowPasswordModal(false);
        setCookies("");
        setSelectedLinkedinIds([]);
      });
  };

  const handlePasswordCancel = () => {
    setShowPasswordModal(false);
    setCookies("");
    setSelectedLinkedinIds([]);
  };

  // Set the scrape and openToWork functions in the parent component
  useEffect(() => {
    setScrapeFunction(() => handleScrape);
    setOpenToWorkFunction(() => handleOpenToWork);
    return () => {
      setScrapeFunction(null);
      setOpenToWorkFunction(null);
    }; // Cleanup when component unmounts
  }, [setScrapeFunction, setOpenToWorkFunction]);

  return (
    <>
      <div
        className="ag-theme-quartz" // applying the Data Grid theme
        style={{}} // the Data Grid will fill the size of the parent container
      >
        <AgGridReact
          rowData={rowData}
          columnDefs={colDefs}
          rowSelection={rowSelection}
          onCellValueChanged={onCellValueChanged}
          getRowId={getRowId}
          onGridReady={onGridReady}
        />
      </div>

      {/* Password Modal */}
      {showPasswordModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg min-w-96">
            <h3 className="text-lg font-semibold mb-4">
              Confirm Scrape Action
            </h3>
            <p className="mb-4">
              You are about to scrape {selectedLinkedinIds.length} profile(s).
            </p>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Cookies (JSON format - optional):
            </label>
            <textarea
              value={cookies}
              onChange={(e) => setCookies(e.target.value)}
              placeholder='{"sessionId": "abc123", "authToken": "xyz789"}'
              rows={4}
              className="w-full px-3 py-2 border border-gray-300 rounded-md mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500 font-mono text-sm"
            />
            <div className="flex justify-end gap-3">
              <button
                onClick={handlePasswordCancel}
                className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
              >
                Cancel
              </button>
              <button
                onClick={handlePasswordConfirm}
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Skills Modal */}
      {skillsModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={() => setSkillsModal(null)}
        >
          <div
            className="bg-white p-6 rounded-lg shadow-lg min-w-96 max-w-xl max-h-[80vh] overflow-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-lg font-semibold mb-4">
              Skills – {skillsModal.name} ({skillsModal.skills.length})
            </h3>
            <div className="flex flex-wrap gap-2 mb-4">
              {skillsModal.skills.map((skill) => (
                <span
                  key={skill}
                  className="px-3 py-1 bg-gray-100 rounded-full text-sm"
                >
                  {skill}
                </span>
              ))}
            </div>
            <div className="flex justify-end">
              <button
                onClick={() => setSkillsModal(null)}
                className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ProspectPage;
